//
// Copyright 2025 DXOS.org
//
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// TODO(thure): Find a way to instruct ESLint & Prettier to treat any whitespace between tags rendered in the `html` template function as significant.
/* eslint-disable */
import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { DxAnchorActivate } from '@dxos/ui-types';
// TODO(thure): There is a case (in)sensitivity issue here which is pernicious:
//   Only refactoring the properties here to all-lowercase fixes the binding in `RefField.tsx`, but that
//   should be unnecessary, and it isn’t an issue for `DxAvatar` or `DxGrid`. What’s going on?
let DxAnchor = class DxAnchor extends LitElement {
    constructor() {
        super(...arguments);
        this.dxn = '';
        this.rootclassname = undefined;
    }
    connectedCallback() {
        super.connectedCallback();
        this.tabIndex = 0;
        this.classList.add(this.getAttribute('data-visible-focus') === 'false' ? 'outline-hidden' : 'dx-focus-ring');
        if (this.rootclassname) {
            this.classList.add(this.rootclassname);
        }
        this.setAttribute('role', 'button');
        if (this.getAttribute('data-auto-trigger') === 'true') {
            this.handleActivate({ type: 'auto-trigger' });
        }
        else {
            this.addEventListener('click', this.handleActivate);
        }
    }
    handleActivate(event) {
        this.dispatchEvent(new DxAnchorActivate({ dxn: this.dxn, label: this.textContent ?? '', trigger: this }));
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: String })
], DxAnchor.prototype, "dxn", void 0);
__decorate([
    property({ type: String })
], DxAnchor.prototype, "rootclassname", void 0);
DxAnchor = __decorate([
    customElement('dx-anchor')
], DxAnchor);
export { DxAnchor };
//# sourceMappingURL=dx-anchor.js.map